import "./Link_module.css";
const Link_module_rslib_entry_ = {
    link: "link-ALIkeV"
};
export { Link_module_rslib_entry_ as default };

//# sourceMappingURL=Link.module.js.map